import styled from "@emotion/styled"
import { Container, Grid, Typography } from "@mui/material"
import * as api from "api"
import ModelName from "common/ModelName"
import ContactUsButton from "components/ContactUs/ContactUsButton"
import Images360 from "components/Images360"
import { memo, useState } from "react"
import Shared from "theme/shared"
import VehicleColors from "./VehicleColors"
import VehicleMissons from "./VehicleMissons"
import VehicleNotices from "./VehicleNotices"
import VehicleOptions from "./VehicleOptions"
import VehiclePrice, { PriceBold } from "./VehiclePrice"

const Styled = {
  Wrapper: styled.div`
    overflow: hidden;
    padding: 0 15px;
    ${(p) => p.theme.breakpoints.up("md")} {
      padding: 0 90px;
    }
  `,
  Grid: styled(Grid)`
    flex-direction: column;

    ${PriceBold}

    ${(p) => p.theme.breakpoints.up("md")} {
      margin-top: 45px;
      flex-direction: row-reverse;
      .left {
        padding-inline-start: 50px;
      }
    }
    ${(p) => p.theme.breakpoints.down("sm")} {
      text-align: center;
    }
  `,
  Wrapper360: styled(Grid)`
    margin-inline-end: -15px;
    margin-inline-start: -15px;
  `,
  ModelName: styled(Typography)`
    font-size: 32px;
    font-weight: bold;
    text-transform: uppercase;
    .span {
      font-weight: regular;
    }

    color: ${(p) => p.theme.colors.oceanBlue};
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-top: 18px;
    }
    ${(p) => p.theme.breakpoints.up("md")} {
      line-height: 1;
      margin: 18px 0;
      font-weight: bold;
      font-size: 66px;
    }
  `,
}

type VehicleDescriptionProps = { data: api.Vehicle }
const VehicleDescription = ({ data }: VehicleDescriptionProps) => {
  const [images, setImages] = useState<api.ImageModel[]>(null)
  const [userChangeColor, setUserChangeColor] = useState<boolean | null>(null)

  return (
    <Container disableGutters>
      <Styled.Wrapper>
        <Styled.Grid container>
          <Grid item sm={12} md={5} className="left">
            <Shared.Reverse>
              <Styled.ModelName variant="h1">
                <ModelName name={data.name} />
              </Styled.ModelName>
              <VehicleMissons data={data.missions} />
            </Shared.Reverse>
            {data.displayPriceWithoutVat && (
              <VehiclePrice price={data.lowestPriceWithoutVat} vat={false} />
            )}
            <VehiclePrice price={data.lowestPriceWithVat} vat={true} />
            <VehicleNotices type="Vehicle" data={data} />
            <Shared.Desktop aboveTheFold>
              <ContactUsButton modelId={data.id} />
            </Shared.Desktop>
          </Grid>
          <Styled.Wrapper360 item sm={12} md={7}>
            <Images360 data={images} userChangeColor={userChangeColor} />
          </Styled.Wrapper360>
        </Styled.Grid>

        <VehicleColors
          data={data.vehicleOutColors}
          onSelected={setImages}
          onUserSelect={() => setUserChangeColor(true)}
        />
        <VehicleOptions data={data.vehicleMainOptions} />
        <Shared.Mobile aboveTheFold>
          <ContactUsButton modelId={data.id} />
        </Shared.Mobile>
      </Styled.Wrapper>
    </Container>
  )
}

export default memo(VehicleDescription)
